import React from 'react';
// @ts-ignore
import { useAppContext } from '../../../Services/AppContext';
import Modal from '../../Modal/Modal';
import AppointmentDetail from './AppointmentDetail';
import { useTreatmentContext } from '../../../Services/TreatmentContext';
import { IResponse } from '../../../Services/ApiClient';

interface IAppointmentDetailModal {
	opened: boolean;
	onClose: any;
	selectedDate: any;
	patientId?: string;
	workplaceId?: string;
	defaultData?: any;
	params?: any;
	onEventIsCreated?: (response: IResponse) => void;
}

export default function AppointmentDetailModal(props: IAppointmentDetailModal) {
	const {
		opened,
		onClose,
		selectedDate,
		patientId,
		workplaceId,
		defaultData,
		params,
		onEventIsCreated,
	} = props;
	const { translation } = useAppContext();
	const { isCase } = useTreatmentContext();

	return (
		<Modal opened={opened} onClose={onClose} wrapChat={isCase}>
			<Modal.Header title={translation['base.shared.orderAPatient']} />
			<Modal.Content>
				<AppointmentDetail
					order={defaultData}
					selectedDate={selectedDate}
					patientId={patientId}
					onSuccess={onClose}
					workplaceId={workplaceId}
					params={params}
					onEventIsCreated={onEventIsCreated}
				/>
			</Modal.Content>
		</Modal>
	);
}
